var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoPaymentZippay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 35,
    viewBox: "0 0 74 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 4.66667C1 2.64162 2.64162 1 4.66667 1H69.3333C71.3584 1 73 2.64162 73 4.66667V41.3333C73 43.3584 71.3584 45 69.3333 45H4.66667C2.64162 45 1 43.3584 1 41.3333V4.66667Z",
    fill: "#FFFFFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4662 16.689L29.3432 31.9599H47.6971L45.82 16.689H27.4662Z",
    fill: "#AA8FFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7021 10.8616C33.8727 11.962 34.0332 13.6929 33.0607 14.7276C32.0881 15.7623 30.3508 15.709 29.1802 14.6085C28.0096 13.508 27.849 11.7771 28.8215 10.7424C29.7941 9.70775 31.5315 9.76107 32.7021 10.8616Z",
    fill: "#1A0826"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.9321 22.1878C66.5096 18.7533 63.8117 16.677 60.1482 16.689H47.9445L49.8216 31.96H55.3138L54.9396 28.9058H60.7518C65.3206 28.9058 67.4149 26.0568 66.9321 22.1878ZM60.1542 24.6263L54.4085 24.6323L53.9558 20.9685L59.7318 20.9745C61.0898 20.9926 61.7838 21.7532 61.8985 22.8034C61.9709 23.4734 61.6631 24.6263 60.1542 24.6263Z",
    fill: "#1A0826"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.35195 27.6926L8.87703 31.96H27.2127L26.6092 27.0769H18.063L17.9845 26.4673L25.8608 20.9685L25.3357 16.689H7L7.59751 21.5781H16.1618L16.2403 22.1878L8.35195 27.6926Z",
    fill: "#1A0826"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66667 2H69.3333V0H4.66667V2ZM72 4.66667V41.3333H74V4.66667H72ZM69.3333 44H4.66667V46H69.3333V44ZM2 41.3333V4.66667H0V41.3333H2ZM4.66667 44C3.19391 44 2 42.8061 2 41.3333H0C0 43.9107 2.08934 46 4.66667 46V44ZM72 41.3333C72 42.8061 70.8061 44 69.3333 44V46C71.9107 46 74 43.9107 74 41.3333H72ZM69.3333 2C70.8061 2 72 3.19391 72 4.66667H74C74 2.08934 71.9107 0 69.3333 0V2ZM4.66667 0C2.08934 0 0 2.08934 0 4.66667H2C2 3.19391 3.19391 2 4.66667 2V0Z",
    fill: "#1A0826"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPaymentZippay);
export default __webpack_public_path__ + "static/media/logo-payment-zippay.fed6391a.svg";
export { ForwardRef as ReactComponent };